export const OB_SIGN_UP_CLICK = 'OnBoarding.Web-App.Header.SignUp-BTN.click';
export const OB_GOOGLE_SSO_CLICK =
  'OnBoarding.Web-App.SignUp-Modal.Google-SSO-BTN.click';
export const OB_CLOSE_BTN_CLICK =
  'OnBoarding.Web-App.SignUp-Modal.Close-BTN.click';
export const OB_SUBMIT_CLICK =
  'OnBoarding.Web-App.SignUp-Modal.Submit-BTN.click';
export const OB_LOGIN_LINK_CLICK =
  'OnBoarding.Web-App.SignUp-Modal.Login-Link.click';
